import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EngagementCard = ({ engagement }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success text-success-foreground';
      case 'Planning':
        return 'bg-warning text-warning-foreground';
      case 'Review':
        return 'bg-accent text-accent-foreground';
      case 'Completed':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getLoBIcon = (lob) => {
    switch (lob) {
      case 'OTC':
        return 'ShoppingCart';
      case 'P2P':
        return 'Package';
      case 'RTR':
        return 'Calculator';
      case 'Plan':
        return 'Target';
      case 'EWM':
        return 'Warehouse';
      default:
        return 'Building2';
    }
  };

  const handleNavigateToQuestionnaire = () => {
    navigate('/questionnaire-runner');
  };

  const handleNavigateToFitGap = () => {
    navigate('/fit-gap-board');
  };

  const handleNavigateToDocuments = () => {
    navigate('/document-generator');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover-lift shadow-elevation-1 hover:shadow-elevation-2 nav-transition">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon 
              name={getLoBIcon(engagement?.lob)} 
              size={20} 
              className="text-primary"
            />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground font-inter">
              {engagement?.name}
            </h3>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <span>{engagement?.lob}</span>
              <span>•</span>
              <span>{engagement?.organization}</span>
            </div>
          </div>
        </div>
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(engagement?.status)}`}>
          {engagement?.status}
        </div>
      </div>
      {/* Progress */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">Progress</span>
          <span className="text-sm text-muted-foreground">{engagement?.progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary rounded-full h-2 nav-transition"
            style={{ width: `${engagement?.progress}%` }}
          />
        </div>
      </div>
      {/* Metrics */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{engagement?.questionsAnswered}</div>
          <div className="text-xs text-muted-foreground">Questions</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{engagement?.fitGapItems}</div>
          <div className="text-xs text-muted-foreground">Fit/Gap</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{engagement?.documents}</div>
          <div className="text-xs text-muted-foreground">Documents</div>
        </div>
      </div>
      {/* Team & Last Activity */}
      <div className="flex items-center justify-between mb-4 text-sm text-muted-foreground">
        <div className="flex items-center space-x-2">
          <Icon name="Users" size={16} />
          <span>{engagement?.teamMembers} members</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={16} />
          <span>{engagement?.lastActivity}</span>
        </div>
      </div>
      {/* Actions */}
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handleNavigateToQuestionnaire}
          iconName="MessageSquare"
          iconPosition="left"
          className="flex-1"
        >
          Questions
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handleNavigateToFitGap}
          iconName="GitCompare"
          iconPosition="left"
          className="flex-1"
        >
          Fit/Gap
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handleNavigateToDocuments}
          iconName="FileText"
          iconPosition="left"
          className="flex-1"
        >
          Docs
        </Button>
      </div>
    </div>
  );
};

export default EngagementCard;